import {
  parseTxSteersGeneratorType,
  STEERS_GENERATOR_TYPE_FIELD_KEY,
} from "encamp-compliance-engine/src/types/facilityStateFieldTypes";

type StateFieldLike = { key: string; value?: unknown };

/**
 * True when a state-fields save changes the facility's TX STEERS generator
 * type as the backend sees it — mirroring the parsed-value comparison the API
 * uses to queue a forced waste-stream reclassification. When this returns
 * true, the save's success toast should set the expectation that waste
 * streams / manifests update shortly (the recalculation runs async) rather
 * than immediately.
 */
export function steersReclassificationQueued(
  before: readonly StateFieldLike[],
  after: readonly StateFieldLike[]
): boolean {
  const submitted = after.find((f) => f.key === STEERS_GENERATOR_TYPE_FIELD_KEY);
  if (!submitted) return false;
  const previous = before.find((f) => f.key === STEERS_GENERATOR_TYPE_FIELD_KEY);
  return (
    parseTxSteersGeneratorType(previous?.value) !== parseTxSteersGeneratorType(submitted.value)
  );
}
